import styled from 'styled-components'

export const BubbleTailIconSVG = styled.svg<{isFromBot: boolean, isTypingComponent: boolean}>`
  position: absolute;
  bottom: 0;
  left: ${({ isFromBot, isTypingComponent }) => isTypingComponent ? '-6px' : isFromBot && '-6px'};
  right: ${({ isFromBot }) => !isFromBot && '-6px'};
  transform: ${({ isFromBot }) => isFromBot && 'scaleX(-1)'};
  filter: ${({ isFromBot }) => isFromBot ? 'drop-shadow(0px 1px 0px rgba(0, 0, 0, 0.04))' : 'none'};
`
